import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup as BSFormGroup } from 'react-bootstrap'

const FormGroup3 = (props) => {
  return (
    <BSFormGroup
      className={props.className}
      validationState={!props.isValid ? 'error' : undefined}
    >
      {props.children}
    </BSFormGroup>
  )
}

FormGroup3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isValid: PropTypes.bool
}

FormGroup3.defaultProps = {
  className: '',
  isValid: true
}

export default FormGroup3
